module.exports = __webpack_public_path__ + "static/media/unis-logos.a14ee5c3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/unis-logos.png
 ** module id = 524
 ** module chunks = 0
 **/